export default {
  // Nav
  'nav.services': 'Services',
  'nav.cases': 'Case Studies',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'nav.cta': 'Free Consult',

  // Hero
  'hero.tag': '/ Full-cycle On-chain Deployment',
  'hero.title.line1': 'Launch digital products',
  'hero.title.line2': 'safely on-chain.',
  'hero.subtitle': 'Angle Forty helps digital product teams ship on blockchain with confidence — from strategy and secure deployment to distribution, monitoring and long-term optimization.',
  'hero.cta.primary': 'Start Your Deployment',
  'hero.cta.secondary': 'Explore Services',
  'hero.stat.projects': 'Projects Shipped',
  'hero.stat.chains': 'Chains Supported',
  'hero.stat.uptime': 'Avg. Uptime',
  'hero.stat.experts': 'In-house Experts',

  // Marquee
  'marquee.item1': 'ETHEREUM',
  'marquee.item2': 'SOLANA',
  'marquee.item3': 'BNB CHAIN',
  'marquee.item4': 'POLYGON',
  'marquee.item5': 'ARBITRUM',
  'marquee.item6': 'BASE',
  'marquee.item7': 'AVALANCHE',

  // About
  'about.tag': '/ Company',
  'about.title': 'From strategy to optimization — a full-cycle partner on chain.',
  'about.desc': 'Angle Forty is built by senior engineers, product operators and financial strategists from the core of the crypto industry. Over 120 digital product teams worldwide trust us to bring their vision on-chain — safely, elegantly, and for the long run.',
  'about.number': '01',
  'about.number.label': 'Full-cycle On-chain Framework',
  'about.number.desc': 'From market discovery, tokenomics design and smart contract deployment, to distribution, data monitoring and continuous optimization — four seamless phases so you can focus on product.',
  'about.cta': 'Explore the Framework',

  // Services
  'services.tag': '/ Core Services',
  'services.title.line1': 'On-chain Launch.',
  'services.title.line2': 'Data-driven Growth.',
  'services.desc': 'Four phases, one integrated delivery. Every step is guarded by a dedicated senior team.',
  'services.s1.title': 'Strategy & Consulting',
  'services.s1.desc': 'Deep discovery of product positioning, target chains and tokenomics — turned into an actionable on-chain roadmap.',
  'services.s1.tag': 'Phase 01',
  'services.s2.title': 'On-chain Deployment',
  'services.s2.desc': 'Smart contract audit, multi-chain deployment and hardened security — every transaction and asset stays traceable.',
  'services.s2.tag': 'Phase 02',
  'services.s3.title': 'Product Operations',
  'services.s3.desc': 'Distribution, community, content strategy and campaigns — engineered to reach your target users at scale.',
  'services.s3.tag': 'Phase 03',
  'services.s4.title': 'Support & Optimization',
  'services.s4.desc': '24/7 monitoring, analytics dashboards and continuous optimization — so your project outlasts the cycle.',
  'services.s4.tag': 'Phase 04',
  'services.s.badge.hot': 'Featured',

  // Cases
  'cases.tag': '/ Case Studies',
  'cases.title': 'Trusted partner on-chain.',
  'cases.desc': 'End-to-end NFT digital collectible launches — from art creation to on-chain deployment.',
  'cases.viewAll': 'View all cases',
  'cases.c1.name': 'Pixel Origin',
  'cases.c1.category': 'NFT · Art Launch Platform',
  'cases.c1.tvl': 'Volume 2,800 ETH',
  'cases.c2.name': 'Vault Society',
  'cases.c2.category': 'NFT · Membership Pass',
  'cases.c2.tvl': '15,000+ Minted',
  'cases.c3.name': 'MetaForge',
  'cases.c3.category': 'NFT · Gaming Assets',
  'cases.c3.tvl': '$12M Volume',
  'cases.c4.name': 'Eden Drop',
  'cases.c4.category': 'NFT · Marketplace',
  'cases.c4.tvl': '280K MAU',

  // Testimonial
  'testimonial.tag': '/ Client Voice',
  'testimonial.quote': 'Angle Forty shipped our multi-chain deployment in 6 weeks — a project we thought would take half a year. Their dashboard finally lets our ops team see the on-chain business clearly.',
  'testimonial.author': 'Yvonne Liao',
  'testimonial.role': 'Co-founder, Pixel Origin',
  'testimonial.verified': 'Verified Partner',

  // CTA
  'cta.tag': '/ Get in Touch',
  'cta.title': 'Ready to launch on-chain?',
  'cta.desc': 'Tell us about your project. A senior consultant will get back to you within 24 hours with a tailored deployment plan.',
  'cta.form.name': 'Your Name',
  'cta.form.email': 'Email',
  'cta.form.company': 'Company / Project',
  'cta.form.type': 'Project Type',
  'cta.form.type.nft.art': 'NFT Art / Digital Collectibles',
  'cta.form.type.nft.gaming': 'NFT Gaming Assets',
  'cta.form.type.nft.membership': 'NFT Membership / Utility',
  'cta.form.type.nft.marketplace': 'NFT Marketplace / Platform',
  'cta.form.type.other': 'Other',
  'cta.form.message': 'Tell us about your project (within 500 chars)',
  'cta.form.submit': 'Send Inquiry',
  'cta.form.submitting': 'Sending…',
  'cta.form.success': 'Thanks! We will reach out within 24 hours.',
  'cta.form.error': 'Something went wrong. Please try again or email hello@angleforty.com',

  // Footer
  'footer.brandDesc': 'Angle Forty — bringing every digital product on-chain, safely and elegantly.',
  'footer.nav.title': 'Navigation',
  'footer.contact.title': 'Contact',
  'footer.social.title': 'Follow',
  'footer.newsletter': 'Subscribe',
  'footer.newsletter.desc': 'One email a month. Only industry insight and case retrospectives.',
  'footer.newsletter.placeholder': 'Your email address',
  'footer.newsletter.button': 'Subscribe',
  'footer.address.title': 'Office',
  'footer.address.value': '9 Queen\'s Road Central, Hong Kong',
  'footer.phone': '+852 3150 0000',
  'footer.email': 'hello@angleforty.com',
  'footer.copyright': '© 2026 Angle Forty Technology Ltd. All rights reserved.',
  'footer.policy.privacy': 'Privacy',
  'footer.policy.terms': 'Terms',

  // Language
  'lang.zh-Hant': '繁中',
  'lang.zh-Hans': '简中',
  'lang.en': 'EN',
  'lang.ja': '日文',
  'lang.ko': '한국어',
};